export const HAKLAI_DOMAIN_VALIDATION_ERRORS = Object.freeze({
  multiplePre1997Homes: "יש לבחור בית מגורים אחד בלבד שבו הבנייה הסתיימה לפני 1.4.1997",
  pre1997AcquisitionDateNotEligible: "לא ניתן לסמן שהבנייה הסתיימה לפני 1.4.1997 כאשר תאריך הרכישה הרלוונטי הוא 01/04/1997 או לאחר מכן",
  pre1997IrrelevantHome: "סימון שהבנייה הסתיימה לפני 1.4.1997 אינו רלוונטי לאחד מבתי המגורים",
  purchaseOrGiftPre1997DateNotEligible: "לא ניתן לסמן שהרכישה והבניה הסתיימו לפני 1.4.1997 כאשר תאריך הרכישה הוא 01/04/1997 או לאחר מכן",
  inheritancePre1997DateNotEligible: "לא ניתן לסמן שהרכישה והבניה הסתיימו לפני 1.4.1997 כאשר תאריך הרכישה של המוריש הוא 01/04/1997 או לאחר מכן",
  purchaseDepreciationModeConflict: "יש לבחור מסלול פחת אחד לרכישה",
  expenseDepreciationSelectionLimit: "ניתן לבחור עד 4 ניכויי פחת",
  missingUsdRateGeneric: "לא ניתן לבצע חישוב ללא שער דולר לתאריך הנדרש"
});

export const HAKLAI_DOMAIN_VALIDATION_LABELS = Object.freeze({
  additionalDeduction: "ניכוי נוסף",
  numberedDeduction: "ניכוי מספר",
  propertyPart: "רכיב הנכס",
  purchase: "רכישה"
});

export const getHaklaiAdditionalDeductionLabel = (targetLabel, count) => (
  `${targetLabel} - ${HAKLAI_DOMAIN_VALIDATION_LABELS.additionalDeduction} ${count}`
);

export const getHaklaiNumberedDeductionLabel = (index) => (
  `${HAKLAI_DOMAIN_VALIDATION_LABELS.numberedDeduction} ${index + 1}`
);

export const getHaklaiPrefixedValidationMessage = (prefix, message) => (
  `${prefix} - ${message}`
);

export const getHaklaiPurchaseValidationMessage = (label, message) => (
  `${HAKLAI_DOMAIN_VALIDATION_LABELS.purchase} - ${label} - ${message}`
);

export const getHaklaiExpenseDepreciationSelectionLimitMessage = (label) => (
  `${label} - ${HAKLAI_DOMAIN_VALIDATION_ERRORS.expenseDepreciationSelectionLimit}`
);

export const getHaklaiMissingUsdRateMessage = (dateLabel = "") => (
  dateLabel
    ? `לא ניתן לבצע חישוב ללא שער דולר לתאריך ${dateLabel}`
    : HAKLAI_DOMAIN_VALIDATION_ERRORS.missingUsdRateGeneric
);
